(() => {
  document.addEventListener('change', (event) => {
    const control = event.target;
    if (!control.matches('.opt-btn, select[name="id"], input[type="radio"][name="id"]')) return;
    const card = control.closest('product-card');
    if (!card) return;
    const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
    const variantId = option?.dataset.variantId || control.value;
    if (!/^\d+$/.test(variantId)) return;

    card.querySelectorAll('.js-prod-link, .bd-card-footer__details, .bd-card-actions > a').forEach((link) => {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.pathname + url.search;
    });
    const title = card.querySelector('.js-variant-title');
    if (title && option.dataset.variantTitle) title.textContent = option.dataset.variantTitle === 'Default Title' ? '' : option.dataset.variantTitle;
    const sku = card.querySelector('.js-variant-sku');
    if (sku && option.dataset.sku) sku.textContent = option.dataset.sku;
    const mediaId = option.dataset.mediaId;
    const media = mediaId ? [...card.querySelectorAll('.card__main-image')].find((image) => image.dataset.mediaId === mediaId) : null;
    if (media && !card.querySelector('product-card-image-slider')) {
      card.querySelectorAll('.card__main-image').forEach((image) => { image.hidden = image !== media; });
    }

    const dimensions = card.querySelector('[data-card-dimensions]');
    if (dimensions && option.hasAttribute('data-dimension-width')) {
      let hasDimensions = false;
      ['width', 'length', 'thickness'].forEach((key) => {
        const value = option.getAttribute(`data-dimension-${key}`) || '';
        const item = dimensions.querySelector(`[data-dimension="${key}"]`);
        item.querySelector('[data-dimension-value]').textContent = value;
        item.hidden = !value;
        hasDimensions = hasDimensions || !!value;
      });
      dimensions.setAttribute('aria-hidden', String(!hasDimensions));
      if (hasDimensions) dimensions.setAttribute('tabindex', '0');
      else dimensions.removeAttribute('tabindex');
    }

    const price = card.querySelector('[data-card-price-display]');
    if (price && option.hasAttribute('data-card-price')) {
      price.querySelector('.price__current').textContent = option.dataset.cardPrice;
      const unit = price.querySelector('.price__unit');
      unit.textContent = option.dataset.cardUnit ? ` / ${option.dataset.cardUnit}` : '';
      unit.hidden = !option.dataset.cardUnit;
      price.querySelector('.bd-card-price__was').textContent = option.dataset.cardWas || '';
      const previousUnit = price.querySelector('.bd-card-price__was-unit');
      if (previousUnit) previousUnit.textContent = unit.textContent;
      price.querySelector('.bd-pct-off').textContent = option.dataset.cardDiscount || '';
      price.querySelector('.bd-card-price__saving').hidden = !option.dataset.cardWas;
    }

    const favorite = card.querySelector('[data-bd-favorite]');
    if (favorite) {
      const key = `${favorite.dataset.bdFavorite.split('-v')[0]}-v${variantId}`;
      const url = new URL(favorite.dataset.bdFavoriteUrl, location.origin);
      url.searchParams.set('variant', variantId);
      favorite.dataset.bdFavorite = key;
      favorite.dataset.bdFavoriteVariant = variantId;
      favorite.dataset.bdFavoriteUrl = url.pathname + url.search;
      if (option.dataset.cardTitle) favorite.dataset.bdFavoriteTitle = option.dataset.cardTitle;
      if (media) favorite.dataset.bdFavoriteImage = media.getAttribute('src');
      if (option.dataset.cardPrice) favorite.dataset.bdFavoritePrice = option.dataset.cardPrice + (option.dataset.cardUnit ? ` / ${option.dataset.cardUnit}` : '');
      if (option.dataset.favoriteSaveLabel) favorite.dataset.bdLabelSave = `${option.dataset.favoriteSaveLabel}: ${favorite.dataset.bdFavoriteTitle}`;
      if (option.dataset.favoriteSavedLabel) favorite.dataset.bdLabelSaved = `${option.dataset.favoriteSavedLabel}: ${favorite.dataset.bdFavoriteTitle}`;
      const saved = window.bdFavorites?.has(key) || false;
      favorite.setAttribute('aria-pressed', String(saved));
      favorite.classList.toggle('is-saved', saved);
      favorite.setAttribute('aria-label', saved ? favorite.dataset.bdLabelSaved : favorite.dataset.bdLabelSave);
    }

    const compare = card.querySelector('.js-compare-checkbox');
    if (compare && compare.dataset.variantId !== variantId) {
      if (compare.checked) {
        compare.checked = false;
        compare.dispatchEvent(new Event('change', { bubbles: true }));
      }
      compare.dataset.variantId = variantId;
      compare.dataset.compareKey = `${compare.dataset.productId}-v${variantId}`;
      const url = new URL(compare.dataset.productUrl, location.origin);
      url.searchParams.set('variant', variantId);
      compare.dataset.productUrl = url.pathname + url.search;
      if (option.dataset.cardTitle) compare.dataset.title = option.dataset.cardTitle;
      if (media) compare.dataset.image = media.getAttribute('src');
    }

    const wrap = card.querySelector('.bd-sample-order-wrap');
    if (wrap) {
      wrap.dataset.lastVariantId = variantId;
      const button = wrap.querySelector('.js-sample-order');
      if (button) button.dataset.variantId = variantId;
      if (option.dataset.samplesOffered) wrap.dataset.initialSamplesOffered = option.dataset.samplesOffered;
      else delete wrap.dataset.initialSamplesOffered;
      wrap.dispatchEvent(new CustomEvent('bd:sample:variant-change', { bubbles: true }));
    }
  });
})();
